import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'utils/routeTitle';

import SiteTemplates from 'component/view/Settings/SiteTemplates';

import { requireOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/templates/')({
  staticData: { routeTitle: t('settings.site_templates.title') },
  beforeLoad: requireOperation({
    options: () => RocketAPI.siteTemplates.getListSiteTemplatesQueryOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: SiteTemplates,
});
